module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-BoldItalic-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-BoldItalic-webfont.woff
// module id = 374
// module chunks = 0